import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  style: {
    "margin": "24px"
  }
};
import { reactive, ref, getCurrentInstance, onActivated } from 'vue';
import { ElMessage } from 'element-plus';
import { useRoute } from 'vue-router';
export default {
  __name: 'editspeciapr',
  setup(__props) {
    const tjdata = reactive({
      promotion_sn: '',
      //编号
      depart: '',
      //部门
      skuname: '',
      //型号
      type: '',
      //类型
      factory_price: '',
      //出厂价
      price: '',
      //清库核算价格/清库特价
      domestic_retail_price: '',
      // 建议国内零售限价($)
      overseas_retail_price: '',
      // 建议海外零售限价($)
      start_time: '',
      //特价失效开始时间
      end_time: '',
      //特价失效结束时间
      stock_start_time: '',
      //库存变现开始时间
      stock_end_time: '',
      //库存变现结束时间
      remark: [],
      //备注
      cpflfromSku: '',
      //产品分类
      nameFromSku: '',
      //名称
      ckldNum: '' // 折扣力度
    });
    let route = useRoute();
    const timeArry = ref([]); // 特价生效/失效时间
    const stocktimeArry = ref([]); // 库存变现生效/失效时间
    onActivated(() => {
      init();
    });
    function init() {
      proxy.$http.get('promotion/info', {
        id: route.query.id
      }).then(res => {
        if (res.errno == 200) {
          tjdata.promotion_sn = res.data.promotion_sn;
          tjdata.depart = res.data.depart;
          tjdata.skuname = res.data.sku;
          tjdata.nameFromSku = res.data.name;
          tjdata.cpflfromSku = res.data.cate_name;
          tjdata.type = res.data.type;
          tjdata.remark = res.data.remark;
          tjdata.factory_price = res.data.factory_price;
          tjdata.price = res.data.price;
          tjdata.start_time = res.data.start_time;
          tjdata.end_time = res.data.end_time;
          tjdata.stock_start_time = res.data.stock_start_time;
          tjdata.stock_end_time = res.data.stock_end_time;
          tjdata.ckldNum = res.data.discount;
          tjdata.id = route.query.id;
          tjdata.domestic_retail_price = res.data.domestic_retail_price;
          tjdata.overseas_retail_price = res.data.overseas_retail_price;
          timeArry.value = [res.data.start_time, res.data.end_time];
          stocktimeArry.value = [res.data.stock_start_time, res.data.stock_end_time];
        }
      });
    }
    const typelist = [{
      label: '停产促销',
      value: 1
    }, {
      label: '仅第三方仓促销',
      value: 2
    }, {
      label: '不停产促销',
      value: 3
    }, {
      label: '战略产品特价',
      value: 4
    }];
    const {
      proxy
    } = getCurrentInstance();
    // 出厂价输入
    function validateNumber(value, key) {
      tjdata[key] = value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, "$1");
      if (key !== 'domestic_retail_price' && key !== "overseas_retail_price") {
        //计算折扣
        if (tjdata.factory_price && tjdata.price) {
          // 定义一个非常小的数作为阈值，用于判断价格是否“几乎为0”  
          const EPSILON = 1e-9;
          // 检查价格是否几乎为0  
          if (Math.abs(tjdata.price) < EPSILON) {
            // 如果价格为0或非常接近于0，你可以将ckldNum设置为0，或者一个你认为合适的默认值  
            tjdata.ckldNum = 0.00; // 或者你想要的任何默认值  
          } else {
            // 否则，进行正常的计算  特价促销的公式  10x特价/出厂价
            if (tjdata.factory_price !== '0' && tjdata.price !== '0') {
              tjdata.ckldNum = parseFloat((tjdata.price * 10 / tjdata.factory_price).toFixed(2));
            }
          }
        } else {
          tjdata.ckldNum = tjdata.price == '0' || !tjdata.price || tjdata.factory_price == '0' || !tjdata.factory_price ? null : tjdata.ckldNum;
        }
      }
    }
    //时间格式处理
    function setTime(date) {
      if (!(date instanceof Date)) {
        date = new Date(date);
      }
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
    // 保存编辑
    function saveedit() {
      if (!tjdata.depart) {
        ElMessage({
          type: 'error',
          message: '请输入部门!'
        });
        return;
      }
      if (!tjdata.type) {
        ElMessage({
          type: 'error',
          message: '请选择类型！'
        });
        return;
      }
      if (!tjdata.factory_price) {
        ElMessage({
          type: 'error',
          message: '请设置出厂价！'
        });
        return;
      }
      if (!timeArry.value || timeArry.value.length !== 2) {
        ElMessage({
          type: 'error',
          message: '请设置特价生效/失效时间！'
        });
        return;
      } else {
        tjdata.start_time = setTime(timeArry.value[0]);
        tjdata.end_time = setTime(timeArry.value[1]);
      }
      if (!stocktimeArry.value || stocktimeArry.value.length !== 2) {
        ElMessage({
          type: 'error',
          message: '请设置库存变现生效/失效时间！'
        });
        return;
      } else {
        tjdata.stock_start_time = setTime(stocktimeArry.value[0]);
        tjdata.stock_end_time = setTime(stocktimeArry.value[1]);
      }
      proxy.$http.post('promotion/edit', tjdata).then(res => {
        if (res.errno == 200) {
          ElMessage({
            type: 'success',
            message: '编辑成功',
            duration: 1500
          });
        } else {
          ElMessage({
            type: 'error',
            message: res.errmsg,
            duration: 1500
          });
        }
      });
    }
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_main = _resolveComponent("el-main");
      return _openBlock(), _createBlock(_component_el_main, {
        class: "wrap_box bg_white"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          class: "title_box head_box"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[0] || (_cache[0] = $event => saveedit())
            }, {
              default: _withCtx(() => _cache[19] || (_cache[19] = [_createTextVNode("保存")])),
              _: 1,
              __: [19]
            })]),
            _: 1
          })]),
          _: 1
        }), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
          ref: "tjFormRef",
          model: tjdata,
          "label-width": "auto",
          class: "demo-ruleForm",
          "label-position": "right"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            class: "tjrow"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "编号"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: tjdata.promotion_sn,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => tjdata.promotion_sn = $event),
                class: "tjit-w-px",
                disabled: ""
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "部门",
              required: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: tjdata.depart,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => tjdata.depart = $event),
                class: "tjit-w-px"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            class: "tjrow"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "规格型号(SKU)",
              required: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: tjdata.skuname,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => tjdata.skuname = $event),
                class: "tjit-w-px",
                disabled: ""
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "类型",
              required: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: tjdata.type,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => tjdata.type = $event),
                placeholder: "",
                class: "tjit-w-px"
              }, {
                default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(typelist, item => {
                  return _createVNode(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 64))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            class: "tjrow"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "名称",
              required: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: tjdata.nameFromSku,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => tjdata.nameFromSku = $event),
                class: "tjit-w-px",
                disabled: ""
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "出厂价",
              required: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: tjdata.factory_price,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => tjdata.factory_price = $event),
                class: "tjit-w-px",
                onInput: _cache[7] || (_cache[7] = $event => validateNumber($event, 'factory_price'))
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            class: "tjrow"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "产品分类",
              required: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: tjdata.cpflfromSku,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => tjdata.cpflfromSku = $event),
                class: "tjit-w-px",
                disabled: ""
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "清库核算价格/清库特价"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: tjdata.price,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => tjdata.price = $event),
                class: "tjit-w-px",
                onInput: _cache[10] || (_cache[10] = $event => validateNumber($event, 'price'))
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            class: "tjrow"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "建议国内零售限价(￥)"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: tjdata.domestic_retail_price,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => tjdata.domestic_retail_price = $event),
                class: "tjit-w-px",
                onInput: _cache[12] || (_cache[12] = $event => validateNumber($event, 'domestic_retail_price'))
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "建议海外零售限价($)"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: tjdata.overseas_retail_price,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => tjdata.overseas_retail_price = $event),
                class: "tjit-w-px",
                onInput: _cache[14] || (_cache[14] = $event => validateNumber($event, 'overseas_retail_price'))
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            class: "tjrow"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "库存变现生效/失效日期",
              required: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: stocktimeArry.value,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => stocktimeArry.value = $event),
                type: "daterange",
                "range-separator": "-",
                "start-placeholder": "请选择生效日期",
                "end-placeholder": "请选择失效日期",
                class: "tjit-w-px"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "清库折扣力度"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: tjdata.ckldNum,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => tjdata.ckldNum = $event),
                class: "tjit-w-px",
                disabled: ""
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            class: "tjrow"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "特价生效/失效日期",
              required: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: timeArry.value,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => timeArry.value = $event),
                type: "daterange",
                "range-separator": "-",
                "start-placeholder": "请选择生效日期",
                "end-placeholder": "请选择失效日期",
                class: "tjit-w-px"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "备注"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: tjdata.remark,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => tjdata.remark = $event),
                type: "textarea",
                class: "tjit-w-px",
                autosize: {
                  minRows: 4
                }
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])])]),
        _: 1
      });
    };
  }
};